import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import AbsoluteFilledLoader from './aqua-delivery-web-client-ui/components/AbsoluteFilledLoader';
import { initConfig } from './config';
import * as serviceWorker from './serviceWorker';
import { MessageType, TokensType } from './types';

import './index.css';

declare global {
    interface Window {
        adminTokens: TokensType;
    }
}

function receiveMessage(event: MessageEvent) {
    const message = event.data as MessageType;
    if (message && message.source && message.source === 'tokens') {
        window.adminTokens = message.payload;
    }
}

window.addEventListener('message', receiveMessage);

if (process.env.NODE_ENV === 'production') console.log = () => {};

const checkAdmin = () => {
    const referrerUrl = document.referrer || window.location.href;
    const url = new URL(referrerUrl);
    const isAdmin = url.searchParams.get('isAdmin');
    if (isAdmin) {
        return !!window.adminTokens;
    }
    return true;
};

function RootComponent() {
    const [isReady, setIsReady] = React.useState(false);

    React.useEffect(() => {
        function receiveMessage(event: MessageEvent) {
            const message = event.data as MessageType;
            if (message && message.source === 'tokens') {
                window.adminTokens = message.payload;
            }
        }

        window.addEventListener('message', receiveMessage);

        const interval = setInterval(() => {
            //@ts-ignore
            if (window.env && checkAdmin()) {
                if (!!window.adminTokens) {
                    window.removeEventListener('message', receiveMessage);
                }
                initConfig();
                setIsReady(true);
                clearInterval(interval);
            }
        }, 1500);

        return () => {
            clearInterval(interval);
            window.removeEventListener('message', receiveMessage);
        };
    }, []);

    return isReady ? <App /> : <AbsoluteFilledLoader />;
}

ReactDOM.render(
    <React.StrictMode>
        <RootComponent />
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
